import React, { useMemo } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import { pluralizeToString } from 'lib/string/pluralize'
import { buildRoomPackageOptionsViewOrder, filterPackageOptionsBySkiPackageType } from 'lib/offer/offerPageUtil'
import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { getCheapestSelectedPackageOption, getDurationPackageOptions, OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import Group from 'components/utils/Group'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import BodyText from 'components/Luxkit/Typography/BodyText'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import FlashHotelRoomOptionVariant from '../FlashHotelRoomOptionVariant'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Pane from 'components/Common/Pane'
import { InOfferFlowContext } from '../RoomOptionsContext'
import FlashMobileStickyHeaderFilters from '../FlashMobileStickyHeaderFilters'

const OptionsContainer = styled.div`
  padding: ${rem(12)} ${rem(20)};
`

interface Props {
  offer: App.HotelOffer;
  packageOptions: Array<OfferPackageOptionView>;
  onBack?: () => void;
  onClose: () => void;
  cheapestSelectedOption?: OfferPackageOptionView;
}

function FlashHotelRoomSelectionModal(props: Props) {
  const {
    offer,
    packageOptions: basePackageOptions,
    onBack,
    onClose,
    cheapestSelectedOption,
  } = props

  // TEMP: Remove this logic when "006RF00000IRdvlYAD" becomes unavailable
  const packageOptions = useMemo(() => {
    return filterPackageOptionsBySkiPackageType(basePackageOptions, cheapestSelectedOption)
  }, [basePackageOptions, cheapestSelectedOption])

  const packageOptionsByRoom = useMemo(() => {
    return buildRoomPackageOptionsViewOrder(packageOptions)
  }, [packageOptions])

  return (
    <>
      <ModalHeader
        title="Select a room"
        onCloseButtonClick={onClose}
        onBackButtonClick={onBack}
      >
        <FlashMobileStickyHeaderFilters />
      </ModalHeader>
      <ModalBody>
        <InOfferFlowContext.Provider value={false}>
          <Group direction="vertical">
            {packageOptionsByRoom.length > 1 && (
              <OptionsContainer>
                <BodyText variant="small" colour="neutral-three">{pluralizeToString('room type', packageOptionsByRoom.length)} available</BodyText>
              </OptionsContainer>
            )}
            <Pane background="neutral-six">
              <VerticalSpacer gap={8}>
                {packageOptionsByRoom.map((item) =>
                  <FlashHotelRoomOptionVariant
                    key={item.roomId}
                    offer={offer}
                    packageViews={item.packageViews}
                    detailsModalMode="room"
                  />,
                )}
              </VerticalSpacer>
            </Pane>
          </Group>
        </InOfferFlowContext.Provider>
      </ModalBody>
    </>
  )
}

export default withOfferPageAndReduxState((state: OfferPageState, appState: App.State) => ({
  offer: state.offer,
  rooms: state.rooms,
  packageOptions: getDurationPackageOptions(state, appState),
  cheapestSelectedOption: getCheapestSelectedPackageOption(appState, state),
}), FlashHotelRoomSelectionModal)
